<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">

        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">{{  $t('PROFILE.PersonalInformation') }}</span>
        </div>

        <!-- Col Content -->
        <div>

          <!-- DOB -->
          <div class="mt-4">
            <label class="text-sm">{{ $t('PROFILE.BirthDate') }}</label>

            <flat-pickr v-if="this.$store.state.userManagement.userProfile.birth_date" :value="`${this.$store.state.userManagement.userProfile.birth_date.split('-')[2]}/${this.$store.state.userManagement.userProfile.birth_date.split('-')[1]}/${this.$store.state.userManagement.userProfile.birth_date.split('-')[0]}`" :config="{ dateFormat: 'd/m/Y', maxDate: new Date() }" class="w-full" v-validate="'required'" @input="setBirthDate" name="dob" />
            <flat-pickr v-else :value="''" :config="{ dateFormat: 'd/m/Y', maxDate: new Date() }" class="w-full" v-validate="'required'" @input="setBirthDate" name="dob" />
            <span class="text-danger text-sm"  v-show="errors.has('dob')">{{ errors.first('dob') }}</span>
          </div>

          <!-- v-validate="{regex: '^\\+?([0-9]+)$' }" -->
          <!-- <vs-input class="w-full mt-4" label="Mobile" v-model="this.$store.state.userManagement.userProfile.mobile" v-mask="'+## (##) #####-####'" name="mobile" @input="setMobile" /> -->
          <!-- <label for="" class="vs-input--label">Mobile</label> -->
          <div class="vs-component vs-con-input-label vs-input w-full mt-4 vs-input-primary">
            <label for="" class="vs-input--label">{{ $t('PROFILE.Mobile') }}</label>
            <div class="vs-con-input"><the-mask type="text" name="mobile" v-model="this.$store.state.userManagement.userProfile.mobile" v-validate="''" @input="setMobile" :mask="['+55 (##) ####-####', '+55 (##) #####-####']" class="vs-inputx vs-input--input normal hasValue" style="border: 1px solid rgba(0, 0, 0, 0.2);"/></div>
            <span class="text-danger text-sm"  v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
          </div>
          <!-- <span class="text-danger text-sm"  v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span> -->

          <vs-input class="w-full mt-4" label="Website" :value="this.$store.state.userManagement.userProfile.website" name="website" v-validate="'alpha_spaces|alpha_dash'" data-vv-as="field" @input="setWebsite" />
          <span class="text-danger text-sm"  v-show="errors.has('website')">{{ errors.first('website') }}</span>

          <div class="mt-4">
            <label class="text-sm">{{ $t('PROFILE.Languages') }}</label>
            <v-select
            v-model="local_language"
            multiple
            :closeOnSelect="true"
            :options="langOptions"
            @input="setLanguages"
            v-validate="'required'"
            name="languages"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
             />
            <span class="text-danger text-sm"  v-show="errors.has('languages')">{{ errors.first('languages') }}</span>
          </div>

          <!-- Gender -->
          <div class="mt-4">
            <label class="text-sm">{{ $t('PROFILE.Gender') }}</label>
            <div class="mt-2">
              <vs-radio vs-name="gender_id" :value="'1'" @change="setGenderId" class="mr-4">{{ $t('PROFILE.Gender') }}</vs-radio>
              <vs-radio vs-name="gender_id" :value="'2'" @change="setGenderId" class="mr-4">{{ $t('PROFILE.Male') }}</vs-radio>
              <vs-radio vs-name="gender_id" :value="'3'" @change="setGenderId">{{ $t('PROFILE.Female') }}</vs-radio>
            </div>
          </div>

          <div class="mt-6">
            <label>{{ $t('PROFILE.ContactOptions') }}</label>
            <div class="flex flex-wrap mt-1">
            <vs-checkbox :value="this.$store.state.userManagement.userProfile.contacts" vs-value="email" @change="setEmailContact" class="mr-4 mb-2">{{ $t('PROFILE.Email') }}</vs-checkbox>
            <vs-checkbox :value="this.$store.state.userManagement.userProfile.contacts" vs-value="message" @change="setMessageContact" class="mr-4 mb-2">{{ $t('PROFILE.Message') }}</vs-checkbox>
            <vs-checkbox :value="this.$store.state.userManagement.userProfile.contacts" vs-value="phone" @change="setPhoneContact" class=" mb-2">{{ $t('PROFILE.Phone') }}</vs-checkbox>
            </div>
          </div>

        </div>
      </div>

      <!-- Address Col -->
      <div class="vx-col w-full md:w-1/2">

          <!-- Col Header -->
          <div class="flex items-end md:mt-0 mt-base">
            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
            <span class="leading-none font-medium">{{ $t('PROFILE.Address') }}</span>
          </div>

          <!-- Col Content -->
          <div>
            <vs-input class="w-full mt-4" :label="$t('PROFILE.AddressLine1')" :value="this.$store.state.userManagement.userProfile.address_line1" @input="setAddressOne" name="address_line_1" />

            <vs-input class="w-full mt-4" :label="$t('PROFILE.AddressLine2')" :value="this.$store.state.userManagement.userProfile.address_line2" @input="setAddressTwo" name="address_line_2"/>

            <vs-input class="w-full mt-4" :label="$t('PROFILE.PostCode')" :value="this.$store.state.userManagement.userProfile.post_code" v-validate="'numeric'" @input="setPostCode" name="post_code" />
            <span class="text-danger text-sm"  v-show="errors.has('post_code')">{{ errors.first('post_code') }}</span>

            <vs-input class="w-full mt-4" :label="$t('PROFILE.City')" name="city" :value="this.$store.state.userManagement.userProfile.city" @input="setCity" />
            <span class="text-danger text-sm"  v-show="errors.has('city')">{{ errors.first('city') }}</span>

            <vs-input class="w-full mt-4" :label="$t('PROFILE.State')" :value="this.$store.state.userManagement.userProfile.state" @input="setState" name="state" />
            <span class="text-danger text-sm"  v-show="errors.has('state')">{{ errors.first('state') }}</span>

            <vs-input class="w-full mt-4" :label="$t('PROFILE.Country')" :value="this.$store.state.userManagement.userProfile.country" @input="setCountry" name="country" />
            <span class="text-danger text-sm"  v-show="errors.has('country')">{{ errors.first('country') }}</span>

          </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{ $t('PROFILE.SaveChanges') }}</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Resetar</vs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {

      mobile: {
        get () {
          return this.$store.state.userManagement.userProfile.mobile
        }
      },

      data_local: null,

      local_language: [],

      all_options: [],

      local_gender: this.$store.state.userManagement.userProfile.gender_id,

      local_contact: {
        get () {
          return ['email', 'message']
        },
        set (value) {

        }
      },

      langOptions: []
    }
  },
  created () {
    const local_lang_options = this.$store.state.auth.languages

    const selected_languages_id = []

    for (const item of Object.values(local_lang_options)) {
      const obj = {label: item.name, value: item.id, hash: item.hash}
      this.langOptions.push(obj)
      this.all_options.push(obj)
    }

    // console.log(this.all_options)

    const local_user_lang_options = this.$store.state.userManagement.userProfile.languages

    for (const item of local_user_lang_options) {
      selected_languages_id.push(item.id)
      this.local_language.push({label: item.name, value: item.id, hash: item.hash})
    }

    this.langOptions = this.langOptions.filter(o => !selected_languages_id.includes(o.value))
  },
  computed: {
    validateForm () {

      const specialRegex = new RegExp('^[0-9a-zA-Z ãâáàéêè\b]+$')


      if (this.$store.state.userManagement.userProfile.languages && this.$store.state.userManagement.userProfile.languages.length === 0) {
        this.errors.add({field: 'languages', msg: this.$t('PROFILE.RequiredField', {field: this.$t('PROFILE.Languages')})})
        return false
      } else {
        this.errors.clear()
      }

      // if(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(this.$store.state.userManagement.userProfile.post_code)) {
      //   this.errors.add({field: 'post_code', msg: 'The Post Code field is must be numeric'})
      //   return false
      // } else {
      //   this.errors.clear()
      // }

      if (this.$store.state.userManagement.userProfile.mobile && this.$store.state.userManagement.userProfile.mobile.length < 10 && this.$store.state.userManagement.userProfile.mobile.length > 0) {
        this.errors.add({field: 'mobile', msg: this.$t('PROFILE.RequiredField', {field: this.$t('PROFILE.Mobile')})})
        return false
      } else {
        this.errors.clear()
      }

      // if(/[a-zA-Z]/g.test(this.$store.state.userManagement.userProfile.post_code)) {
      //  this.errors.add({field: 'post_code', msg: 'The Post Code field is must be numeric'})
      //  return false
      // } else {
      //   this.errors.clear()
      // }

      // if(/\d/.test(this.$store.state.userManagement.userProfile.city)) {
      //   this.errors.add({field: 'city', msg: 'The city field may only contain alphabetic characters as well as spaces'})
      //   return false
      // } else {
      //   this.errors.clear()
      // }

      // if(!specialRegex.test(this.$store.state.userManagement.userProfile.city)) {
      //   this.errors.add({field: 'city', msg: 'The city field may only contain alphabetic characters as well as spaces underscore'})
      //   return false
      // } else {
      //   this.errors.clear()
      // }

      // if(/\d/.test(this.$store.state.userManagement.userProfile.state)) {
      //   this.errors.add({field: 'state', msg: 'The state field may only contain alphabetic characters as well as spaces'})
      //   return false
      // } else {
      //   this.errors.clear()
      // }

      // if(!specialRegex.test(this.$store.state.userManagement.userProfile.state)) {
      //   this.errors.add({field: 'state', msg: 'The state field may only contain alphabetic characters as well as spaces'})
      //   return false
      // } else {
      //   this.errors.clear()
      // }

      // if(/\d/.test(this.$store.state.userManagement.userProfile.country)) {
      //   this.errors.add({field: 'country', msg: 'The country field may only contain alphabetic characters as well as spaces'})
      //   return false
      // } else {
      //   this.errors.clear()
      // }

      // if(!specialRegex.test(this.$store.state.userManagement.userProfile.country)) {
      //   this.errors.add({field: 'country', msg: 'The country field may only contain alphabetic characters as well as spaces'})
      //   return false
      // } else {
      //   this.errors.clear()
      // }

      if (!this.$store.state.userManagement.userProfile.name) {
        this.$vs.notify({
          title: this.$t('PROFILE.Warning'),
          text: this.$t('PROFILE.NameFieldRequired'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      } else if (/\d/.test(this.$store.state.userManagement.userProfile.name)) {
        this.$vs.notify({
          title: this.$t('PROFILE.Warning'),
          text: this.$t('PROFILE.NameFieldAlphaSpaces'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      } else if (!specialRegex.test(this.$store.state.userManagement.userProfile.name)) {
        this.$vs.notify({
          title: this.$t('PROFILE.Warning'),
          text: this.$t('PROFILE.ValidNameAccountTab'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      // if(/\d/.test(this.$store.state.userManagement.userProfile.website)) {
      //   this.errors.add({field: 'website', msg: 'The website field may only contain alphabetic characters as well as spaces'})
      //   return false
      // } else {
      //   this.errors.clear()
      // }

      // if(/[`!#$%^&*()_+\-=\[\]{};'"\\|,<>\?~]/.test(this.$store.state.userManagement.userProfile.website)) {
      //   console.log('opa')
      //   this.errors.add({field: 'website', msg: 'The website field may contain alpha-numeric characters as well as dashes and underscores'})
      //   return false
      // } else {
      //   this.errors.clear()
      // }

      if (/\s/.test(this.$store.state.userManagement.userProfile.name) && this.$store.state.userManagement.userProfile.name.trim() === '') {
        this.$vs.notify({
          title: this.$t('PROFILE.Warning'),
          text: 'The name field in Account Tab must be a valid name',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return !this.errors.any()
    }
  },
  methods: {
    setBirthDate (e) {
      if (e) {
        const date = `${e.split('/')[2]}-${e.split('/')[1]}-${e.split('/')[0]}`
        this.$store.commit('userManagement/setBirthDate', date)
      } else {
        this.$store.commit('userManagement/setBirthDate', null)
      }
    },
    setMobile (e) {
      this.$store.commit('userManagement/setMobile', e.replace('+', '').replace('-', '').replace(' ', '').replace('(', '').replace(')', '').replace(' ', ''))
    },
    setWebsite (e) {
      this.$store.commit('userManagement/setWebsite', e)
    },
    setAddressOne (e) {
      this.$store.commit('userManagement/setAddressOne', e)
    },
    setAddressTwo (e) {
      this.$store.commit('userManagement/setAddressTwo', e)
    },
    setGenderId (e) {
      this.$store.commit('userManagement/setGenderId', parseInt(e.target.value))
    },
    setPostCode (e) {
      this.$store.commit('userManagement/setPostCode', e)
    },
    setCity (e) {
      this.$store.commit('userManagement/setCity', e)
    },
    setState (e) {
      this.$store.commit('userManagement/setState', e)
    },
    setCountry (e) {
      this.$store.commit('userManagement/setCountry', e)
    },
    setEmailContact (e) {
      this.$store.commit('userManagement/setEmailContact', e.includes('email'))
    },
    setMessageContact (e) {
      this.$store.commit('userManagement/setMessageContact', e.includes('message'))
    },
    setPhoneContact (e) {
      this.$store.commit('userManagement/setPhoneContact', e.includes('phone'))
    },
    setLanguages (e) {
      const selected_languages_id = []

      for (const item of e) {
        selected_languages_id.push(item.value)
      }

      this.langOptions = this.all_options.filter(o => !selected_languages_id.includes(o.value))


      this.$store.commit('userManagement/setLanguages', e)
    },

    async fetch_user_data (userSession, appToken, apiUrl) {
      this.$vs.loading({type: 'default'})
      return await this.$store.dispatch('userManagement/fetchUserProfile', {userSession, appToken, apiUrl})
        .then((res) => {
          this.$vs.loading.close()
          this.$store.dispatch('userManagement/setUserProfile', res)
          this.user_data = res
        })
        .catch(err => {
          this.$vs.loading.close()
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
    },

    save_changes () {

      /* eslint-disable */
      if (!this.validateForm) return

      this.$vs.loading({type: 'default'})

      this.$store.dispatch('userManagement/saveChanges', {userProfile: this.$store.state.userManagement.userProfile, apiUrl: this.$store.state.auth.api_url})
      .then(async (result) => {
        this.$vs.loading.close()

        await this.fetch_user_data(this.$store.state.auth.token, this.$store.state.auth.app_token, this.$store.state.auth.api_url)

        this.$store.commit('auth/SET_USER_NAME', this.$store.state.userManagement.userProfile.name)
        this.$store.commit('auth/SET_USER_PHOTO', this.$store.state.userManagement.userProfile.photo)
        this.$store.commit('auth/SET_USER_USERNAME', this.$store.state.userManagement.userProfile.username)
        this.$store.commit('auth/SET_USER_MOBILE', this.$store.state.userManagement.userProfile.mobile)
        localStorage.setItem('user', JSON.stringify(this.$store.state.auth.user))

        this.$vs.notify({
            title: this.$t('PROFILE.SuccessOperation'),
            text: this.$t('PROFILE.DataSuccessfullyChanged'),
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })

          // console.log(document.querySelectorAll('button.vs-con-dropdown.parent-dropdown.cursor-pointer')[3].children[0].children[0].src)
          // console.log(this.$store.state.auth.user.photo)

        // document.querySelectorAll('button.vs-con-dropdown.parent-dropdown.cursor-pointer')[3].children[0].children[0].src = this.$store.state.auth.user.photo + '#' + new Date().getTime()

      })
      .catch((err) => {
        console.log(err)
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Erro',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
        })
      })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = Object.assign({}, this.data)
    }
  }
}
</script>
